/* TapScore · runtime de secciones */
    if (!window.TSS) {
      window.TSS = (function () {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const fino = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        const ready = (fn) => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, { once: true }) : fn());
        const grupo = (c, d, t, s) => {
          const p = (Math.floor(c) / 100).toFixed(d).split('.');
          return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (p[1] ? s + p[1] : '');
        };
        const money = (c) => {
          if (window.TS && window.TS.money) return window.TS.money(c);
          const f = String(window.tsMoneyFormat || '').replace(/<[^>]*>/g, '');
          if (!f || f.indexOf('amount') === -1) return new Intl.NumberFormat(document.documentElement.lang || 'es-MX', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN' }).format(c / 100);
          return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
            if (k === 'amount_no_decimals') return grupo(c, 0, ',', '.');
            if (k === 'amount_with_comma_separator') return grupo(c, 2, '.', ',');
            if (k === 'amount_no_decimals_with_comma_separator') return grupo(c, 0, '.', ',');
            return grupo(c, 2, ',', '.');
          });
        };
        const motion = () => document.documentElement.classList.contains('ts-motion');
        const roll = (el, texto) => {
          if (!el) return;
          if (window.TS && window.TS.roll && motion()) return window.TS.roll(el, texto);
          el.textContent = texto;
        };
        let ioVivo = false;
        const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => {
          ioVivo = true;
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }), { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;
        const tilt = (el) => {
          if (!fino || reduce || el.dataset.tsTiltOn) return;
          el.dataset.tsTiltOn = '1';
          el.addEventListener('pointermove', (e) => {
            const r = el.getBoundingClientRect();
            el.style.setProperty('--ry', (((e.clientX - r.left) / r.width - 0.5) * 2).toFixed(3));
            el.style.setProperty('--rx', ((0.5 - (e.clientY - r.top) / r.height) * 2).toFixed(3));
          });
          el.addEventListener('pointerleave', () => {
            el.style.setProperty('--rx', '0');
            el.style.setProperty('--ry', '0');
          });
        };
        const scan = (raiz) => {
          if (!raiz) return;
          raiz.querySelectorAll('[data-ts-reveal]:not(.is-in)').forEach((el) => (io && motion() ? io.observe(el) : el.classList.add('is-in')));
          if (raiz.dataset.ts3d === 'true') raiz.querySelectorAll('[data-ts-tilt]').forEach(tilt);
        };
        const activar = (raiz) => {
          if (!raiz) return;
          if (raiz.dataset.tsMotion === 'true' && raiz.dataset.tsEditor !== 'true' && !reduce && io) {
            document.documentElement.classList.add('ts-motion');
            setTimeout(() => {
              if (!ioVivo) raiz.querySelectorAll('[data-ts-reveal]').forEach((el) => el.classList.add('is-in'));
            }, 2500);
          }
          scan(raiz);
          if (reduce) raiz.querySelectorAll('svg').forEach((s) => s.pauseAnimations && s.pauseAnimations());
        };
        const track = (evento, vid, qty, centavos) => {
          if (!document.querySelector('[data-ts-tracking="true"]')) return;
          const cp = window.Shopify && Shopify.customerPrivacy;
          if (cp && typeof cp.analyticsProcessingAllowed === 'function' && !cp.analyticsProcessingAllowed()) return;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: evento, variant_id: vid, quantity: qty, value: centavos / 100, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN' });
        };
        const variante = () => {
          const i = document.querySelector('form[id^="product-form-"] input[name="id"]');
          if (i) return i.disabled ? null : Number(i.value);
          const p = document.querySelector('ts-packs, tsx-packs');
          return p ? Number(p.dataset.variante || 0) || null : null;
        };
        const propiedades = () => {
          const p = {};
          document.querySelectorAll('[data-ts-prop]').forEach((i) => {
            const v = i.value.trim();
            if (v) p[i.dataset.tsProp] = v;
          });
          return p;
        };
        const validar = () => {
          let ok = true;
          document.querySelectorAll('ts-negocio, tsx-negocio').forEach((n) => {
            if (ok && n.validar && !n.validar()) ok = false;
          });
          return ok;
        };
        const toast = (tipo, texto) => (window.TS && TS.toast ? TS.toast(tipo, texto) : window.TSX_TOAST ? window.TSX_TOAST(tipo, texto) : null);
        const addToCart = async (items, source) => {
          const propio = document.querySelector('tsx-carrito');
          if (propio && typeof propio.agregar === 'function') return propio.agregar(items);
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const body = { items };
          if (cart && typeof cart.getSectionsToRender === 'function') {
            body.sections = cart.getSectionsToRender().map((s) => s.id);
            body.sections_url = window.location.pathname;
          }
          const r = await fetch(routes.cart_add_url, { ...fetchConfig('javascript'), body: JSON.stringify(body) });
          const state = await r.json();
          if (state.status) {
            publish(PUB_SUB_EVENTS.cartError, { source, productVariantId: items[0].id, errors: state.errors || state.description, message: state.message });
            return state;
          }
          if (!cart) {
            window.location.href = routes.cart_url;
            return state;
          }
          publish(PUB_SUB_EVENTS.cartUpdate, { source, productVariantId: items[0].id, cartData: state });
          cart.renderContents(state);
          cart.classList.remove('is-empty');
          const interior = cart.querySelector('.drawer__inner');
          if (interior) interior.classList.remove('is-empty');
          return state;
        };
        const irAFicha = () => {
          const destino = document.querySelector('ts-negocio, tsx-negocio') || document.querySelector('ts-packs, tsx-packs') || document.querySelector('form[id^="product-form-"]');
          if (destino) destino.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        };
        const pack = () => {
          const p = document.querySelector('ts-packs, tsx-packs');
          return p && p.estado ? p.estado() : null;
        };
        const cta = async (btn) => {
          if (!btn || btn.disabled || btn.classList.contains('is-cargando')) return;
          const accion = btn.dataset.accion || 'pack';
          if (accion === 'url') {
            if (btn.dataset.url) window.location.href = btn.dataset.url;
            return;
          }
          if (accion === 'formulario') return irAFicha();
          const p = document.querySelector('ts-packs, tsx-packs');
          if (accion === 'pack' && p && p.comprar) {
            btn.classList.add('is-cargando');
            try {
              await p.comprar();
            } finally {
              btn.classList.remove('is-cargando');
            }
            return;
          }
          if (!validar()) return;
          const vid = variante() || Number(btn.dataset.variante || 0) || null;
          if (!vid) return irAFicha();
          const item = { id: vid, quantity: 1 };
          const props = propiedades();
          if (Object.keys(props).length) item.properties = props;
          const precio = Number(btn.dataset.precio || 0);
          btn.classList.add('is-cargando');
          try {
            if (accion === 'checkout') {
              const r = await fetch(routes.cart_add_url, { ...fetchConfig('javascript'), body: JSON.stringify({ items: [item] }) });
              const s = await r.json();
              if (!s.status) {
                track('marca_initiate_checkout', vid, 1, precio);
                window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout';
              }
              return;
            }
            const s = await addToCart([item], 'tsx-cta');
            if (!s.status) track('marca_add_to_cart', vid, 1, precio);
          } finally {
            btn.classList.remove('is-cargando');
          }
        };
        const pintarPrecios = (detalle) => {
          document.querySelectorAll('[data-tss-cta]').forEach((b) => {
            const pr = b.querySelector('[data-tss-precio]');
            if (detalle && detalle.total && (b.dataset.accion || 'pack') === 'pack') {
              if (pr) roll(pr, money(detalle.total));
              b.dataset.precio = detalle.total;
            } else if (pr && b.dataset.precio) {
              roll(pr, money(Number(b.dataset.precio)));
            }
          });
          document.querySelectorAll('[data-tss-total]').forEach((el) => {
            if (detalle && detalle.total) roll(el, money(detalle.total));
          });
        };
        document.addEventListener('ts:pack', (e) => pintarPrecios(e.detail));
        document.addEventListener('click', (e) => {
          const b = e.target.closest('[data-tss-cta]');
          if (b) {
            e.preventDefault();
            cta(b);
          }
        });
        ready(() => {
          pintarPrecios(pack());
          if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
            subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
              const v = data && data.variant;
              if (!v) return;
              document.querySelectorAll('[data-tss-cta]').forEach((b) => {
                if ((b.dataset.accion || 'pack') !== 'pack' || !document.querySelector('ts-packs, tsx-packs')) b.dataset.precio = v.price;
              });
              setTimeout(() => pintarPrecios(pack()), 30);
            });
          }
        });
        document.addEventListener('shopify:section:load', (e) => activar(e.target.querySelector('.tsx')));
        return { reduce, fino, ready, money, roll, activar, scan, tilt, track, cta, addToCart, pack, irAFicha, variante, toast, propiedades, validar };
      })();
    }
    // Compatibilidad con secciones viejas que traen su propia copia (sin estas funciones)
    if (window.TSS && !window.TSS.propiedades) {
      (function () {
        const propiedades = () => {
          const p = {};
          document.querySelectorAll('[data-ts-prop]').forEach((i) => {
            const v = i.value.trim();
            if (v) p[i.dataset.tsProp] = v;
          });
          return p;
        };
        const validar = () => {
          let ok = true;
          document.querySelectorAll('ts-negocio, tsx-negocio').forEach((n) => {
            if (ok && n.validar && !n.validar()) ok = false;
          });
          return ok;
        };
        const toast = (tipo, texto) => (window.TS && TS.toast ? TS.toast(tipo, texto) : window.TSX_TOAST ? window.TSX_TOAST(tipo, texto) : null);
        Object.assign(window.TSS, { propiedades, validar, toast });
      })();
    }
    if (!window.TSSQ || Array.isArray(window.TSSQ)) (function () {
      const cola = Array.isArray(window.TSSQ) ? window.TSSQ : [];
      const correr = (fn) => { try { fn(); } catch (e) { console.error('TapScore:', e); } };
      window.TSSQ = { push: correr };
      // lo que ya está en pantalla se muestra sin animación (una sola medición, sin recalcular por elemento)
      const alto = window.innerHeight;
      const enPantalla = Array.from(document.querySelectorAll('.tsx [data-ts-reveal]:not(.is-in)')).filter((el) => { const b = el.getBoundingClientRect(); return b.top < alto && b.bottom > 0; });
      enPantalla.forEach((el) => el.classList.add('is-in'));
      let i = 0;
      const paso = () => {
        const t0 = performance.now();
        while (i < cola.length && performance.now() - t0 < 40) correr(cola[i++]);
        if (i < cola.length) setTimeout(paso, 0);
      };
      paso();
    })();
